export default __webpack_public_path__ + "static/media/menu_my_profile.09e4efa4.svg";